export default __webpack_public_path__ + "static/media/logout.1a7673cd.svg";